/**
 * Created by lihanying on 2017/7/1.
 */
import React from 'react'
import { Modal, Input, Switch } from 'antd'

export default class extends React.Component {
  state = {
    name: '',
    materials: this.props.record.materials || '0',
  }

  onChange = (value) => {
    let materials = '0'
    if (value) {
      //原材料
      materials = '1'
    }
    this.setState({ materials: materials })
  }

  onCheckout = (item) => {
    let checkout = false
    if (item === '1') {
      checkout = true
    }
    return checkout
  }

  render() {
    const { visible, record, type } = this.props
    let data
    if (type === '1') {
      data = {
        id: record.id,
        name: this.state.name || record.name,
        type: 0,
        materials: this.state.materials,
      }
    } else {
      data = {
        name: this.state.name,
        type: 0,
        materials: this.state.materials,
      }
    }

    return (
      <div>
        <Modal
          title={record.name ? '修改分类' : '添加分类'}
          visible={visible}
          onOk={() => this.props.handleOk(data)}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <div className="diamond-item">
            <span className="diamond-span">分类名称:</span>
            <Input
              size="large"
              defaultValue={record.name}
              style={{ width: '50%', marginLeft: '1rem' }}
              placeholder="请输入商品名称"
              onChange={(e) => this.setState({ name: e.target.value })}
            />
          </div>
          <div className="diamond-item">
            <span>是否为原材料:</span>
            <Switch
              defaultChecked={this.onCheckout(record.materials)}
              onChange={this.onChange}
              style={{ marginLeft: '1rem' }}
            />
          </div>
          <p>提示:原材料不会显示在自助点餐中</p>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodityType/component/modalDetail.js